import { render, staticRenderFns } from "./CardGroupData.vue?vue&type=template&id=1e960694&lang=pug&"
import script from "./CardGroupData.vue?vue&type=script&lang=js&"
export * from "./CardGroupData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports